import { Component, Input } from "@angular/core";
import { CdkStepper, STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";

@Component({
	selector: "app-stepper",
	templateUrl: "./stepper.component.html",
	styleUrls: ["./stepper.component.scss"],
	providers: [
		{ provide: CdkStepper, useExisting: StepperComponent },
		{
			provide: STEPPER_GLOBAL_OPTIONS,
			useValue: { displayDefaultIndicatorType: false }
		}
	],
	standalone: false
})
export class StepperComponent extends CdkStepper {
	@Input() showConnectors = true;
	@Input() showLabels = true;

	protected selectStepByIndex(index: number): void {
		this.selectedIndex = index;
	}
}
